// config/flags.ts
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// FEATURE FLAGS CONFIGURATION
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//
// Feature flags are checked in this order:
// 1. Environment variables (e.g., NEXT_PUBLIC_ENABLE_ONBOARDING_COMPANY_LOGO_UPLOAD=true)
// 2. Hardcoded fallback values below
//
// To enable a feature via environment:
//   Add NEXT_PUBLIC_ENABLE_ONBOARDING_COMPANY_LOGO_UPLOAD=true to your .env file
//
// To enable a feature via code (fallback):
//   Change false → true in the FEATURE_FLAGS object below
//
// ⚠️  REMEMBER: Every flag is temporary!
//     Set removal date when creating a flag.
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

export const FEATURE_FLAGS = {
  // Created: 2026-06-13 | Owner: WisdomBridge | Remove by: 2026-09-13
  enable_onboarding_company_logo_upload: true,
  
  // Created: 2026-06-18 | Owner: WisdomBridge | Remove by: 2026-09-18
  enable_stakeholder_invite_link_sharing: true,

  // Created: 2026-07-04 | Owner: WisdomBridge | Remove by: 2026-10-04
  enable_bulk_upload_documents: true,

  // Created: 2026-08-30 | Owner: WisdomBridge | Remove by: 2026-11-30
  enable_bulk_document_blob_upload: true,
} as const

export type FlagName = keyof typeof FEATURE_FLAGS
